<template>
    <div class="layout-pods">
        <header class="layout-pods-header pg-header">
            <div></div>
            <form id="client-search" class="search-form campaigns-client-search">
                <input class="form-control" type="search" placeholder="Search" aria-label="Search" v-model="searchCampaigns">
            </form>
        </header>
        <div class="pods-container">
            <article class="pods-wrapper">
                <campaign-item :add-new="false" v-for="(campaign, index) in filteredCampaigns" :campaign="campaign" :key="index"></campaign-item>
            </article>
        </div>
    </div>
</template>

<script>
    import CampaignItem from './CampaignItem';
    import CampaignServices from '../../services/campaigns';
    import CampaignPerimeters from '../../configs/Perimeters/campaigns';
    import { refreshPageMixin } from '../../mixins/refreshPage';

    export default {
        mixins: [refreshPageMixin],
        perimeters: [CampaignPerimeters],
        components: {
            CampaignItem
        },
        data() {
            return {
                showModal: false,
                campaignId: false,
                campaigns: [],
                searchCampaigns: "",
            }
        },
        computed: {
            filteredCampaigns: function() {
                return this.campaigns.filter((campaign) => {
                    return campaign.property.title.toLowerCase().match(this.searchCampaigns.toLowerCase());
                });
            }
        },
        methods: {
            getCampaigns(status) {
                CampaignServices.getCampaigns(status, 'agency').then( campaigns => {
                    this.campaigns = campaigns.data;
                });
            }
        },
        watch: {
            hashChanged(newVal) {
                if (newVal) {
                    this.getCampaigns('published');
                }
            }
        },
        mounted() {
            this.getCampaigns('published');
        }
    }
</script>

<style lang="css">
</style>
